<template>
  <div 
    @click="navigate"
    class="group bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer border border-transparent hover:border-gray-100">
    
    <div :class="`w-20 h-20 bg-${color}-100 text-${color}-600 rounded-3xl flex items-center justify-center text-5xl mb-8 group-hover:scale-110 transition-transform duration-300`">
      {{ icon }}
    </div>
    
    <h4 class="text-2xl font-semibold text-gray-900 mb-3">{{ title }}</h4>
    <p class="text-gray-600 leading-relaxed text-[15.5px]">{{ description }}</p>
    
    <div class="mt-10 flex items-center text-blue-600 font-medium text-sm group-hover:gap-2 transition-all">
      Open Dashboard
      <span class="text-2xl leading-none translate-x-0 group-hover:translate-x-1 transition">→</span>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

// ✅ Correct way to define and destructure props
const { route } = defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: 'blue'
  },
  route: {
    type: String,
    required: true
  }
})

const navigate = () => {
  if (route) {
    router.push(route)
  }
}
</script>